/* istanbul ignore file */
export * from './getGraphqlApolloRouterBaseUrl';
